<template>
  <div class="notification">
    <div class="notification__wrapper">
      <el-badge :value="notifUnread">
        <svg class="notification__bell"  @click.stop="showNotifBody"
        @animationend="shakeBell = false" :class="{'notification__bell--shakeMe': shakeBell}" >
          <use href="../assets/sprite.svg#icon-bell-o"></use>
        </svg>
      </el-badge>
      <div class="notification__body" v-show="showBody"  v-hide-on-click.outside="showBody">
        <transition-group name="notif" tag="div">
          <div class="card card--read" v-for="(notif, index) in notifications" :key="notif._id">
            <img :src="notif.from != undefined ? notif.from.avatar : null" />
            <div>
              <div class="card__title-box">
                <span class="card__title-username">{{notif.from.firstname}} {{notif.from.name}}</span>
                <div>
                  <span class="card__title-date">{{notif.createAt | moment}}</span>
                  <svg @click="delNotif(notif._id,index)" class="card__close u-pointer">
                    <use href="../assets/sprite.svg#icon-cancel"></use>
                  </svg>
                </div>
              </div>
              <div class='card__content'>{{notif.msg}}</div>
            </div>
          </div>
        </transition-group>
        <infinite-loading ref="notifInfiniteScroll"  @infinite="getNotif" :distance="1" >
          <div slot="no-more"></div>
          <div slot="no-results">{{$t('notification.noNotif')}}</div>
        </infinite-loading>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP_CLIENT } from '../axios-wrapper'
import { toastMixin } from '@/components/Mixins/Toast'
import InfiniteLoading from 'vue-infinite-loading'
import moment from 'moment'

export default {
  name: 'Notifications',
  data () {
    return {
      notifications: [],
      page: 1,
      showBody: false,
      shakeBell: false,
      notifUnread: 0,
      onMessagefnID: undefined
    }
  },
  components: {
    InfiniteLoading
  },
  mixins: [toastMixin],
  filters: {
    moment: function (date) {
      return moment(date).fromNow()
    }
  },
  methods: {
    getNotif: async function ($state) {
      // Recuperation des notif sur le serveur
      let { data } = await HTTP_CLIENT.get(`/notification?page=${this.page}&limit=2&sort=-createAt`)
      if (data.length) {
        this.notifications.push(...data)
        $state.loaded()
      } else {
        $state.complete()
      }
      this.page++
    },
    async getUnreadCount () {
      // NbrNotif
      let { data } = await HTTP_CLIENT.get(`/notification/unread/count`)
      this.notifUnread = data.count
    },
    showNotifBody: function () {
      this.shakeBell = false
      this.showBody = true

      this.$nextTick(() => {
        if (this.page === 1) {
          this.$refs['notifInfiniteScroll'].attemptLoad()
        }
      })
    },
    notificationHTML5: function (msg) {
      if ('Notification' in window) {
        if (Notification.permission === 'granted') {
          const notif = new Notification(msg)
          setTimeout(() => {
            notif.close()
          }, 10000)
        }
      }
    },
    delNotif: async function (id, index) {
      try {
        let { status } = await HTTP_CLIENT.delete(`/notification/${id}`)
        if (status === 204) {
          this.notifications.splice(index, 1)
          this.getUnreadCount()
        }
      } catch (error) {
        this.sendErrorToast(this.$t('feedback-err.notification.delete'))
      }
    }
  },
  async mounted () {
    // NbrNotif
    this.getUnreadCount()
    moment.locale('fr')
  },
  async created () {
    // Ajout de la fn a appelle onmessage websocket
    this.onMessagefnID = await this.$store.dispatch('notification/ADD_FN', {
      fn: (notif) => {
        notif = JSON.parse(notif.data)
        this.notifications.push(notif)
        this.notificationHTML5(notif.msg)
        this.shakeBell = true
        this.notifUnread++
      }
    })
  },
  destroyed () {
    this.$store.commit('notification/REMOVE_FN', this.onMessagefnID)
  }
}
</script>
